
<template>
  <div>
    <!-- <button @click="SetIsTest">isTest</button> -->
    <div v-if="isDebug">
      <button @click="scenes.scene = !scenes.scene">scene</button>
      <button @click="scenes.opening = !scenes.opening">video</button>
      <button @click="TestNextScene">Next Scene</button>
      <button @click="TestEnding">Ending</button>
      <button @click="TestReload">Reload</button>
    </div>

    <Menu :scenes="scenes" />
    <div class="scene-wrap paper-bg"></div>
    <Start :scenes="scenes" :lang="lang" />
    <Scene
      :scenes="scenes"
      :sceneDisplay="sceneDisplay"
      :currentScene="currentScene"
      :level="level"
      :lang="lang"
    />
    <div class="scene-wrap paper-frame"></div>
    <Video :scenes="scenes" :isTest="isTest" />
    <Ending
      :scenes="scenes"
      :visitedScene="visitedScene"
      :isDebug="isDebug"
      :isTest="isTest"
      :lang="lang"
    />
    <Loading
      :isLoading="isLoading"
      :scenes="scenes"
      :currentScene="currentScene"
      :isDebug="isDebug"
      :isTest="isTest"
    />
    <audio
      ref="audio"
      class="audio"
      preload
      loop
      src="/media/opening.mp3"
      type="audio/mp3"
    ></audio>
  </div>
</template>

<script>
import $ from "jquery";

// import { onErrorCaptured } from "vue";

import Menu from "./components/Menu.vue";
import Start from "./components/Start.vue";
import Video from "./components/Video.vue";
import Scene from "./components/Scene.vue";
import Loading from "./components/Loading.vue";
import Ending from "./components/Ending.vue";

// import taskData from "./assets/data/task.json";
import taskData from "./assets/data/task.json";

export default {
  name: "App",
  components: {
    Menu,
    Start,
    Scene,
    Video,
    Loading,
    Ending,
  },
  data() {
    return {
      isOpen: true,
      isLoading: true,
      scenes: [
        {
          start: false,
          scene: false,
          opening: false,
          ending: false,
          loading: false,
        },
      ],
      show: true,
      currentScene: 0,
      level: 0,
      visitedScene: [],
      sceneDisplay: [true, false, false, false, false],
      tasks: taskData,
      isDebug: false,
      isTest: false,
      lang: "en",
    };
  },
  setup() {
    // console.log("setup");


    return {};
  },
  created() {
    // this.isDebug = true;
    // this.isTest = true;

    //setup lang
    $("html").attr("lang", this.lang);

    if (this.isDebug) {
      var test;
      // test = "ending";

      switch (test) {
        case "ending":
          this.scenes.ending = true;
          break;
        default:
          var scene = 2;
          this.sceneDisplay[0] = false;
          this.sceneDisplay[scene] = true;
          this.currentScene = scene;
          this.scenes.scene = true;
          break;
      }
    } else {
      this.StartGame();
    }

    //emitters
    this.emitter.on("show-scene", () => {
      this.emitter.emit("start-loading");

      //wait
      setTimeout(
        function () {
          this.scenes.scene = true;
          $(".audio").attr("src", this.tasks[this.currentScene]["audio"]);
          this.AudioController();
        }.bind(this),
        1000
      );

      console.log("[app] show scene");
    });
    this.emitter.on("hide-scene", () => {
      this.scenes.scene = false;
      // this.scenes.scene = false;
      console.log("[app] hidescene");
    });
    this.emitter.on("hide-start", () => {
      this.scenes.start = false;
      // this.scenes.scene = false;
      console.log("[app] hidescene");
    });
    this.emitter.on("show-opening", () => {
      this.emitter.emit("start-loading");
      //wait
      setTimeout(
        function () {
          this.scenes.opening = true;
        }.bind(this),
        1000
      );
      console.log("[app] show opening");
    });
    this.emitter.on("hide-opening", () => {
      this.scenes.opening = false;
      this.emitter.emit("show-scene");
      // this.scenes.scene = true;
      console.log("[app] hide opening");
    });
    this.emitter.on("next-scene", (id) => {
      this.currentScene = id;
      this.level++;

      this.visitedScene.push(id);
      // gameController.UpdateSceneData(id);
      //set secne
      for (var i = 0; i < 5; i++) {
        this.sceneDisplay[i] = false;
      }
      this.sceneDisplay[this.currentScene] = true;
      // console.log(this.sceneDisplay);
      console.log(this.visitedScene);
      console.log("[app] update scene data");
      // console.log("[app] this.currentScene" + this.currentScene);
    });

    this.emitter.on("show-ending", () => {
      this.level++;
      this.emitter.emit("hide-scene");
      this.emitter.emit("start-loading");
      setTimeout(
        function () {
          this.scenes.ending = true;
          var audioSrc = "/media/ending-1.mp3";
          $(".audio").attr("src", audioSrc);
          this.AudioController();

          // this.$nextTick(function () {
          //   this.emitter.emit("finish-loading");
          // });
          // $(".audio").attr("src", this.tasks[this.currentScene]["audio"]);
        }.bind(this),
        1000
      );
      console.log("[app] show ending");
    });

    this.emitter.on("start-loading", () => {
      this.isLoading = true;
      this.scenes.loading = true;
      console.log("[app] start loading");
    });

    this.emitter.on("finish-loading", () => {
      this.isLoading = false;
      console.log("[app] finish loading");
    });

    this.emitter.on("show-loading", () => {
      this.emitter.emit("show-loading");
      this.$nextTick(
        function () {
          this.scenes.loading = true;
        }.bind(this),
        1000
      );
      // console.log("[app] show ending");
    });

    this.emitter.on("hide-loading", () => {
      this.scenes.loading = false;
      console.log("[app] hide loading");
    });

    this.emitter.on("restart", () => {
      Object.assign(this.$data, this.$options.data.apply(this));

      //for testing
      // this.isTest = true;

      this.StartGame();
      console.log("[app] restart game");
    });
  },
  methods: {
    StartGame() {
      var src = "/media/opening.mp3";
      $(".audio").attr("src", src);
      this.scenes.loading = true;
      //wait
      setTimeout(
        function () {
          this.scenes.start = true;
          this.isLoading = false;
          this.$nextTick(function () {
            this.isLoading = false;
          });
        }.bind(this),
        500
      );
    },
    TestNextScene() {
      console.log("[Debug] Next scene");
      var newScene = this.currentScene + 1;
      this.emitter.emit("next-scene", newScene);
    },
    TestEnding() {
      this.emitter.emit("show-ending");
    },
    TestReload() {
      this.emitter.emit("restart");
    },
    SetIsTest() {
      this.isTest = true;
    },
    AudioController() {
      if ($(".audio-btn").hasClass("audio-off")) {
        $(".audio")[0].pause();
      } else {
        $(".audio")[0].play();
      }
    },
  },
};
</script>
